import { BrowserCacheLocation, InteractionType, LogLevel } from '@azure/msal-browser';
import { Environment } from './environment.model';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1 ||
  window.navigator.userAgent.indexOf('Edge') > -1;

/**
 * This file will be replaced during prod build through the prebuild.js script.
 * That way, prod setting apply for deployed versions.
 */
export const environment: Environment = {
  production: false,
  azureEndpoint: 'https://staging.api.schenck.one',
  apiBaseUrl: 'https://staging.api.schenck.one/rm/v1', // against deployed/cloud backend
  usBaseUrl: 'https://staging.api.schenck.one/user', // against deployed/cloud backend
  umBaseUrl: 'https://staging.api.schenck.one/um/v2/rights/RM', // against deployed/cloud backend
  amBaseUrl: 'https://staging.api.schenck.one/am/v1', // against deployed/cloud backend
  googleApiKey: 'AIzaSyCaCOvpgCooOPqfq4yIgpasYKr2-k9xIWQ',
  versionInfo: {
    tag: 'staging',
    hash: 'd30c8c39dd1e13a77b204eb24828a4f12b95d23a',
    buildtimestamp: '2026-10-08T07:45:53.8105650Z',
    buildVersion: '3.0.0+3931',
  },
  msalConfig: {
    msal: {
      auth: {
        clientId: '497a2c95-7de9-4f67-9f91-2f652bd46c0b',
        knownAuthorities: ['durrgroupb2c.b2clogin.com'],
        authority: 'https://durrgroupb2c.b2clogin.com/durrgroupb2c.onmicrosoft.com/B2C_1A_SIGNIN',
        redirectUri: 'https://staging.rotormanager.schenck.one',
        postLogoutRedirectUri: 'https://staging.rotormanager.schenck.one/postlogout',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        storeAuthStateInCookie: true, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    },
    guard: {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: [
          'https://durrgroupb2c.onmicrosoft.com/fe173409-9be8-45ff-a77d-184f3ec74c50/API.All',
        ],
      },
      loginFailedRoute: '/login-failed',
    },
  },
};
